<template>
  <v-container>
    <h1>Vilkår for {{ vendor.name }}</h1>

    <v-card class="mt-10">
      <!-- eslint-disable vue/no-v-html -->
      <v-card-text v-html="organization.terms_rendered"></v-card-text>
      <!--eslint-enable-->
    </v-card>
  </v-container>
</template>

<script>
import backend from "@/backend";

export default {
  name: "VendorTerms",

  props: {
    vendorId: {
      type: String,
      required: true,
    },
  },

  data: function () {
    return {
      vendor: {},
      organization: {},
    };
  },

  async created() {
    this.vendor = await backend.get(`vendors/${this.vendorId}/`);
    this.organization = await backend.get(
      `organizations/${this.vendor.organization}/`
    );
  },
};
</script>
